/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState } from 'react'
import { MyPolicy } from '../../auth/core/_models'
import { AcsGlobalBaseEnrollmentListModel } from './AcsGlobalBaseEnrollmentListModel'

type Props = {
  className: string
  title: string
  description: string
  avatar: string
  Email: string | undefined
  CrmUrl: string | undefined
  MyPolicy: MyPolicy | null
  onRefresh?: () => void
}

const AcsGlobalBaseEnrollmentLinkWidget: React.FC<Props> = ({ className, title, description, avatar, Email, CrmUrl, MyPolicy, onRefresh }) => {
  const [modalShow, setModalShow] = useState(false)

  const handleClose = () => {
    setModalShow(false)
    onRefresh?.()
  }

  return (
    <>
      <a className={` hoverable`} onClick={() => setModalShow(true)}>
        <div className='border bg-light-primary border-primary border-dashed rounded 
                           py-3 px-4 me-6 mb-3 border-hover-success 
                          bg-hover-primary text-hover-white'>
          <div className='d-flex align-items-center'>
            <div className='fs-6 fw-bolder'> Enroll Family </div>
          </div>
        </div>
      </a>

      <AcsGlobalBaseEnrollmentListModel
        show={modalShow}
        handleClose={handleClose}
        Title={title}
        Email={Email}
        CrmUrl={CrmUrl}
        MyPolicy={MyPolicy}
      />
    </>
  )
}

export { AcsGlobalBaseEnrollmentLinkWidget }
